// src/components/ProfileCard.jsx
import { fetchAccounts } from "../../api/api" // Assuming this is the correct path to fetchAccounts
import { useState, useEffect } from "react"
import api from "../../api/api"  // Assuming this is the correct path to the shared api instance

export function ProfileCard({ profile, onLoadToCalculator, accountId }) { // Added onLoadToCalculator and accountId
    const [showPicker, setShowPicker] = useState(false)
    const [accounts, setAccounts] = useState([])
    const [selected, setSelected] = useState([])
  
    // 1) load user’s accounts when modal opens
    useEffect(() => {
        if (!showPicker) return;
      
        fetchAccounts()
          .then((data) => setAccounts(data))
          .catch((err) => {
            console.error("Error fetching accounts:", err);
            alert("Could not load your accounts.");
          });
      }, [showPicker]);
  
    // 2) when user clicks “Apply”, open the picker
    const onApplyClick = () => {
      setSelected([])        // clear any old selections
      setShowPicker(true)
    }
  
    // 3) once they confirm, fire one PATCH per account
    const onConfirm = async () => {
      if (!selected.length) {
        alert("Please select at least one account.")
        return
      }
  
      try {
        await Promise.all(
          selected.map(acctId =>
            api.patch(`/risk/settings/${acctId}/`, {
              default_tp_profile_id: profile.id,
            })
          )
        );
        alert(`Applied “${profile.name}” to ${selected.length} account(s).`);
      } catch (err) {
        console.error("Apply error", err);
        alert("Failed to apply profile—please try again");
      } finally {
        setShowPicker(false);
      }
    };
  
    return (
      <div className="bg-backgroundSurface p-4 shadow rounded-lg border border-borderDefault"> {/* Card styles */}
        <h3 className="text-lg font-semibold mb-2 text-textPrimary">{profile.name}</h3> {/* Title */}
        
        {/* Display partial targets info if available - basic example */}
        {profile.partial_targets && profile.partial_targets.length > 0 && (
          <div className="text-xs text-textSecondary mb-3"> {/* Partial targets text */}
            {profile.partial_targets.map((pt, index) => (
              <span key={index} className="mr-2">
                TP{index + 1}: {pt.size_pct}% @ {pt.r_multiple}R
              </span>
            ))}
          </div>
        )}

        <div className="flex space-x-2 mt-auto"> {/* Buttons at the bottom */}
          {onLoadToCalculator && (
            <button
              onClick={() => onLoadToCalculator(profile)}
              className="mt-3 btn btn-secondary flex-1" // Use a different style
              title={`Load ${profile.name} into calculator`}
            >
              Load to Calc
            </button>
          )}
          <button 
            onClick={onApplyClick} 
            className="mt-3 btn btn-primary flex-1"
            title={`Apply ${profile.name} to trading account(s)`}
          >
            Apply to Account
          </button>
        </div>
  
        {showPicker && (
          <div className="fixed inset-0 bg-textPrimary/50 flex items-center justify-center z-50"> {/* Modal overlay, added z-50 */}
            <div className="bg-backgroundSurface p-6 rounded shadow-lg w-96"> {/* Modal content */}
              <h4 className="mb-4 text-lg text-textPrimary">Select Account(s)</h4> {/* Modal title */}
              <div className="max-h-60 overflow-auto">
                {accounts.map((acct) => (
                  <label key={acct.id} className="flex items-center mb-2 cursor-pointer"> {/* Checkbox label */}
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-primary border-borderDefault rounded focus:ring-primary mr-2" /* Checkbox styles */
                      value={acct.id}
                      checked={selected.includes(acct.id)}
                      onChange={(e) => {
                        const id = e.target.value // Ensure id is correctly captured; string from value, number if parsed
                        setSelected((prev) =>
                          e.target.checked
                            ? [...prev, id] 
                            : prev.filter((x) => x !== id)
                        )
                      }}
                    />
                    <span className="text-textPrimary">{acct.name || acct.id}</span> {/* Checkbox text */}
                  </label>
                ))}
              </div>
              <div className="mt-4 flex justify-end space-x-2">
                <button
                  onClick={() => setShowPicker(false)}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button onClick={onConfirm} className="btn btn-primary">
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  export default ProfileCard
